import Chapter from "./Chapter";
import { motion } from "framer-motion";
import { ASSETS } from "./assets";

const STEPS = [
  {
    n: "01",
    title: "Positionnement",
    desc: "Grâce à son profil bas et à ses chenilles, la plateforme se glisse sous le véhicule, même dans un espace réduit ou sur sol dégradé.",
  },
  {
    n: "02",
    title: "Levage",
    desc: "Le plateau soulève le châssis de 13 à 45 cm, jusqu'à 3 000 kg, en toute stabilité — sans cric ni point de levage spécifique.",
  },
  {
    n: "03",
    title: "Déplacement ou extinction",
    desc: "Déplacez le véhicule au centimètre près vers la zone voulue, ou déclenchez la projection d'eau pour maîtriser un incendie.",
  },
];

export default function HowItWorks() {
  return (
    <section id="process" data-testid="how-it-works-section" className="py-24 lg:py-32 bg-[#0A0A0A] text-white">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <Chapter index={2} label="Comment ça marche" />
            <h2 className="font-display mt-4 text-3xl md:text-4xl font-bold tracking-tight">
              Trois gestes. Un véhicule maîtrisé.
            </h2>
            <p className="mt-4 text-lg text-white/60">
              Un opérateur, une commande à distance, et n'importe quel véhicule devient déplaçable et
              sécurisable en quelques minutes.
            </p>

            <div className="mt-8">
              {STEPS.map((s, i) => (
                <motion.div
                  key={s.n}
                  data-testid={`step-${i}`}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  className={`flex gap-6 py-7 ${i !== STEPS.length - 1 ? "border-b border-white/10" : ""}`}
                >
                  <div className="font-mono-tech text-2xl font-bold text-[#E63946] shrink-0 w-12">{s.n}</div>
                  <div>
                    <h3 className="font-display text-xl font-bold tracking-tight">{s.title}</h3>
                    <p className="mt-2 text-white/60 leading-relaxed">{s.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-7"
          >
            <div className="relative rounded-sm overflow-hidden border border-white/10 bg-black aspect-[4/3]">
              <img src={ASSETS.underVehicle} alt="Mécanisme de levage à chenilles sous un véhicule"
                className="absolute inset-0 h-full w-full object-cover" />
              <div className="absolute bottom-3 left-3 right-3 flex flex-wrap gap-2">
                <span className="font-mono-tech text-[11px] uppercase tracking-wider text-white bg-black/70 border border-white/10 px-2.5 py-1 rounded-sm">Mécanisme ciseaux</span>
                <span className="font-mono-tech text-[11px] uppercase tracking-wider text-white bg-black/70 border border-white/10 px-2.5 py-1 rounded-sm">Chenilles motorisées</span>
                <span className="font-mono-tech text-[11px] uppercase tracking-wider text-white bg-black/70 border border-white/10 px-2.5 py-1 rounded-sm">Levage par le châssis</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
